import React from 'react';
import QuoteMachine from './components/QuoteMachine';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <QuoteMachine />
    </div>
  );
}

export default App;
